import React, { useEffect, useState } from "react";
import { markdown } from "markdown";
import { ContentSection } from "../Layout/ContentSection";
import { api } from "../api";
import { API_ModFeed, Toast } from "../../../src/apidefs";
import { IsTag } from "../models/tags";
import { IsComment } from "../models/comments";
import { IsVote } from "../models/vote";
import { RLink } from "../DesignSystem/RLink";

const formatMarkdown = (content: string) =>
  markdown.toHTML(content.replace(":thonk:", "![thonk](/img/thonk.png)") || "");

export const ModFeedPage = (): JSX.Element => {
  const [modFeed, setModFeed] = useState<API_ModFeed | undefined>();

  useEffect(() => {
    let cancelled = false;

    const fetchFeed = async () => {
      const response = (await api.get(`/api/modfeed`)) as API_ModFeed | Toast;
      if (!api.isToast(response) && !cancelled) {
        setModFeed(response);
      } else if (!cancelled) {
        setModFeed(undefined);
      }
    };

    fetchFeed();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!modFeed) {
    return <span>Loading...</span>;
  }

  return (
    <div>
      <ContentSection>
        {modFeed.map((item) => {
          if (IsTag(item)) {
            return (
              <div key={`tag-${item.entry_id}-${item.tag}`} className="p-5">
                <strong>New tag</strong>: {item.tag}
                <div>
                  on <RLink to={`/entry/${item.entry_id}`}>{item.title}</RLink>
                  &nbsp; by{" "}
                  <RLink to={`/users/${item.username}`}>{item.username}</RLink>
                </div>
              </div>
            );
          }

          if (IsComment(item)) {
            return (
              <div
                key={`comment-${item.entry_id}-${item.username}`}
                className="p-5"
              >
                <strong>New comment</strong>:
                <div
                  className="prose"
                  dangerouslySetInnerHTML={{
                    __html: formatMarkdown(item.content),
                  }}
                />
                <div>
                  on <RLink to={`/entry/${item.entry_id}`}>{item.title}</RLink>
                  &nbsp; by{" "}
                  <RLink to={`/users/${item.username}`}>{item.username}</RLink>
                </div>
              </div>
            );
          }

          if (IsVote(item)) {
            return (
              <div
                key={`vote-${item.entry_id}-${item.username}`}
                className="p-5"
              >
                <strong>New review:</strong>

                <div
                  className="prose"
                  dangerouslySetInnerHTML={{
                    __html: formatMarkdown(item.review),
                  }}
                />

                <div>
                  on <RLink to={`/entry/${item.entry_id}`}>{item.title}</RLink>
                  &nbsp; by{" "}
                  <RLink to={`/users/${item.username}`}>{item.username}</RLink>
                </div>
              </div>
            );
          }

          return <div key={JSON.stringify(item)}>???</div>;
        })}
      </ContentSection>
    </div>
  );
};
